import request from '../../utils/request'
import server from './config'
export default {
  /**
   * 获取保单入组告知协议
   */
  enterGroupPreview:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/insurance/1/enterGroupPreview`,
      method: 'post',
      data,
    })
  },
  /**
   * 获取保单列表
   */
  getPageList:(data,noToast = false)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/insurance/1/getPageList`,
      method: 'post',
      data,
      noToast
    })
  },
  //获取保单详情
  insuranceEnterGroupInfoGetById:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/insurance/1/insuranceEnterGroupInfoGetById`,
      method: 'post',
      data,
    })
  },
  // 石分关爱-获取器械列表
  getDeviceConfigurationList:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/insurance/1/getDeviceConfigurationList`,
        method: 'post',
        data
    })
  },

  // 石分关爱-领取器械
  applyMedicalDevice:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/applyMedicalDevice`,
        method: 'post',
        data
    })
  },

  // 发票信息
  getInvoiceRecordInfo:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/invoiceRecord/1/getInvoiceRecordInfo`,
        method: 'post',
        data
    })
  },

  // 发票开具信息
  getListByGoodsId:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/invoiceRecord/1/getListByGoodsId`,
        method: 'post',
        data
    })
  },

  // 查看所选器械详情
  getDeviceDetailByServiceOrderId:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/getDeviceDetailByServiceOrderId`,
        method: 'post',
        data
    })
  },


}


// WEBPACK FOOTER //
// ./src/api/modules/insurance.js